/* Sunday Home theme scripts */
(function () {
  'use strict';

  /* ---------- Mobile / mega nav drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;

    var panel = drawer.querySelector('.drawer__panel');
    var closeBtn = drawer.querySelector('.drawer__close');
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = drawer.querySelectorAll('[data-drawer-close]');
    var lastOpener = null;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      // move focus into the dialog for keyboard/screen-reader users
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (panel) panel.style.overflowY = '';
      drawer.querySelectorAll('[data-sub]').forEach(function (s) { s.classList.remove('is-open'); });
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      // return focus to whatever opened the drawer
      if (lastOpener) { lastOpener.focus(); lastOpener = null; }
    }

    openers.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        lastOpener = b;
        open();
      });
    });
    closers.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Drill into subcategories
    // NOTE: sub-panel absolute hai; agar panel scrolled ho to sub khisak jata tha.
    // Is liye drill pe panel ko top pe reset + scroll-lock (sub khud scroll karega).
    drawer.querySelectorAll('[data-drill]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = drawer.querySelector('[data-sub="' + btn.getAttribute('data-drill') + '"]');
        if (target) {
          if (panel) { panel.scrollTop = 0; panel.style.overflowY = 'hidden'; }
          target.classList.add('is-open');
        }
      });
    });
    // Back from subcategories
    drawer.querySelectorAll('[data-sub-back]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var sub = btn.closest('[data-sub]');
        if (sub) sub.classList.remove('is-open');
        // scroll wapas tabhi jab koi sub baaki na ho (L3 -> L2 pe locked rehna chahiye)
        if (panel && !drawer.querySelector('[data-sub].is-open')) panel.style.overflowY = '';
      });
    });
  }

  /* ---------- Wishlist (localStorage of product handles) ---------- */
  var WKEY = 'sh_wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function setWish(list) { localStorage.setItem(WKEY, JSON.stringify(list)); }

  function toggleWish(handle) {
    var list = getWish();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    setWish(list);
    paintWish();
  }

  function paintWish() {
    var list = getWish();
    document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-wishlist')) !== -1);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {
      badge.textContent = list.length;
      badge.style.display = list.length ? 'flex' : 'none';
    });
  }

  // Single delegated handler covers both static cards and freshly rendered ones
  function bindWish(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleWish(btn.getAttribute('data-wishlist'));
      if (document.querySelector('[data-wishlist-grid]')) renderWishlistPage();
    });
  }

  function initWishlistButtons() {
    document.querySelectorAll('[data-wishlist]').forEach(bindWish);
    paintWish();
  }

  /* ---------- Shared helpers ---------- */
  // routes.root_url aksar '/' hota hai; trailing slash na hatao to '//products/x'
  // ban jata hai -> browser "products" ko HOST samajh kar DNS fail karta hai.
  function shopRoot() {
    return ((window.SundayHome && window.SundayHome.root) || '').replace(/\/+$/, '');
  }

  function money(cents) {
    var cfg = window.SundayHome || {};
    try {
      return new Intl.NumberFormat(cfg.locale || 'nl-BE', { style: 'currency', currency: cfg.currency || 'EUR' }).format((cents || 0) / 100);
    } catch (e) {
      return '€ ' + ((cents || 0) / 100).toFixed(2).replace('.', ',');
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHTML(p) {
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    return '' +
      '<div class="card">' +
        '<div class="card__media">' +
          '<a href="' + esc(p.url) + '" class="frame">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="card__fav is-active" data-wishlist="' + esc(p.handle) + '" aria-label="Verwijder uit favorieten">' +
            '<svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6"><path d="M12 21s-8-5.3-10-9.5C.6 8 2.4 4.5 6 4.5c2.4 0 4 1.5 6 3.8 2-2.3 3.6-3.8 6-3.8 3.6 0 5.4 3.5 4 7-2 4.2-10 9.5-10 9.5z"></path></svg>' +
          '</button>' +
          (onSale ? '<span class="card__badge">Sale</span>' : '') +
        '</div>' +
        '<a href="' + esc(p.url) + '" class="card__info">' +
          '<span class="card__title">' + esc(p.title) + '</span>' +
          (p.type ? '<span class="card__sub">' + esc(p.type) + '</span>' : '') +
          '<span class="price' + (onSale ? ' on-sale' : '') + '"><span class="now">' + money(p.price) + '</span>' + (onSale ? '<span class="was">' + money(p.compare_at_price) + '</span>' : '') + '</span>' +
        '</a>' +
      '</div>';
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var root = shopRoot();
    var list = getWish();

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = 'block';
      return;
    }
    if (empty) empty.style.display = 'none';

    Promise.all(list.map(function (handle) {
      return fetch(root + '/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(cardHTML).join('');
      grid.innerHTML = html || '';
      if (!html && empty) empty.style.display = 'block';
      paintWish();
      // bind the hearts we just injected
      grid.querySelectorAll('[data-wishlist]').forEach(bindWish);
    });
  }

  /* ---------- Recently viewed ---------- */
  // Product page pe handle record karo, warna 'sh_recent' kabhi bharti hi nahi
  // (renderRecent sirf parhta hai). Agar product template khud likhta hai to
  // ye bas dedupe kar dega — nuksan nahi.
  var RKEY = 'sh_recent', RECENT_MAX = 12;
  function trackRecent() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (e) {}
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RKEY, JSON.stringify(list.slice(0, RECENT_MAX))); } catch (e) {}
  }

  function renderRecent() {
    var grid = document.querySelector('[data-recent-grid]');
    if (!grid) return;
    var wrap = grid.closest('[data-recent-wrap]');
    var root = shopRoot();
    var limit = parseInt(grid.getAttribute('data-recent-limit'), 10) || 4;
    var exclude = grid.getAttribute('data-recent-exclude');
    var list = [];
    try { list = JSON.parse(localStorage.getItem('sh_recent') || '[]'); } catch (e) {}
    list = list.filter(function (h) { return h && h !== exclude; }).slice(0, limit);
    if (!list.length) return;

    Promise.all(list.map(function (h) {
      return fetch(root + '/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var items = products.filter(Boolean);
      if (!items.length) return;
      grid.innerHTML = items.map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var sale = p.compare_at_price && p.compare_at_price > p.price;
        return '<div class="card">' +
          '<div class="card__media"><a href="' + esc(p.url) + '" style="display:block;height:100%;">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<button type="button" class="card__fav" data-wishlist="' + esc(p.handle) + '" aria-label="Favoriet"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 21s-8-5.3-10-9.5C.6 8 2.4 4.5 6 4.5c2.4 0 4 1.5 6 3.8 2-2.3 3.6-3.8 6-3.8 3.6 0 5.4 3.5 4 7-2 4.2-10 9.5-10 9.5z"></path></svg></button>' +
          '</div>' +
          '<a href="' + esc(p.url) + '" class="card__info">' +
            '<span class="card__name">' + esc(p.title) + '</span>' +
            (p.type ? '<span class="card__type">' + esc(p.type) + '</span>' : '') +
            '<span class="card__price"><span>' + money(p.price) + '</span>' + (sale ? '<span class="was">' + money(p.compare_at_price) + '</span>' : '') + '</span>' +
          '</a>' +
        '</div>';
      }).join('');
      if (wrap) wrap.style.display = '';
      paintWish();
      grid.querySelectorAll('[data-wishlist]').forEach(bindWish);
    });
  }

  /* ---------- Cart drawer (AJAX add-to-cart) ---------- */
  function cartDrawerEls() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return null;
    return {
      drawer: drawer,
      lines: drawer.querySelector('[data-cart-drawer-lines]'),
      empty: drawer.querySelector('[data-cart-drawer-empty]'),
      foot: drawer.querySelector('[data-cart-drawer-foot]'),
      count: drawer.querySelector('[data-cart-drawer-count]'),
      subtotal: drawer.querySelector('[data-cart-drawer-subtotal]')
    };
  }

  function openCartDrawer() {
    var els = cartDrawerEls();
    if (!els) return;
    els.drawer.classList.add('is-open');
    els.drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    var els = cartDrawerEls();
    if (!els) return;
    els.drawer.classList.remove('is-open');
    els.drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function renderCartDrawer(cart) {
    var els = cartDrawerEls();
    if (!els) return;
    if (els.count) els.count.textContent = cart.item_count;
    if (els.subtotal) els.subtotal.textContent = money(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (!cart.item_count) {
      if (els.lines) els.lines.innerHTML = '';
      if (els.empty) els.empty.style.display = 'block';
      if (els.foot) els.foot.style.display = 'none';
      return;
    }
    if (els.empty) els.empty.style.display = 'none';
    if (els.foot) els.foot.style.display = 'flex';
    if (!els.lines) return;

    els.lines.innerHTML = cart.items.map(function (item, i) {
      var img = item.image || '';
      return '<div class="cart-drawer__line" data-line="' + (i + 1) + '">' +
        (img ? '<img src="' + esc(img) + '&width=200" alt="' + esc(item.product_title) + '">' : '') +
        '<div class="meta">' +
          '<a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<span class="sub">' + esc(item.variant_title) + '</span>' : '') +
          '<div class="qty">' +
            '<button type="button" data-cart-qty="-1">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-cart-qty="1">+</button>' +
          '</div>' +
        '</div>' +
        '<span class="price">' + money(item.final_line_price) + '</span>' +
        '<button type="button" class="remove" data-cart-remove aria-label="Verwijderen">✕</button>' +
      '</div>';
    }).join('');

    els.lines.querySelectorAll('[data-cart-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.closest('[data-line]').getAttribute('data-line');
        var delta = parseInt(btn.getAttribute('data-cart-qty'), 10);
        var span = btn.parentElement.querySelector('span');
        var qty = Math.max(0, parseInt(span.textContent, 10) + delta);
        changeCartLine(line, qty);
      });
    });
    els.lines.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.closest('[data-line]').getAttribute('data-line');
        changeCartLine(line, 0);
      });
    });
  }

  function fetchCart() {
    return fetch(shopRoot() + '/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  function changeCartLine(line, quantity) {
    var els = cartDrawerEls();
    if (els) els.drawer.classList.add('cart-drawer__loading');
    fetch(shopRoot() + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCartDrawer(cart);
      if (els) els.drawer.classList.remove('cart-drawer__loading');
    });
  }

  function addToCartAjax(form) {
    var formData = new FormData(form);
    var body = {};
    formData.forEach(function (v, k) { body[k] = v; });
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.dataset.origText = btn.dataset.origText || btn.textContent; btn.textContent = '...'; btn.disabled = true; }

    fetch(shopRoot() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () {
      return fetchCart();
    }).then(function () {
      openCartDrawer();
    }).catch(function (err) {
      alert((err && err.description) || 'Kon niet toevoegen aan winkelwagen.');
    }).finally(function () {
      if (btn) { btn.textContent = btn.dataset.origText; btn.disabled = false; }
    });
  }

  function initCartDrawer() {
    var els = cartDrawerEls();
    if (!els) return;

    document.querySelectorAll('[data-cart-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); closeCartDrawer(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCartDrawer(); });

    // Intercept product-form submits site-wide
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        addToCartAjax(form);
      }
    });

    // Cart icon opens drawer instead of navigating
    document.querySelectorAll('[data-cart-icon]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(openCartDrawer);
      });
    });

    fetchCart();
  }

  /* ---------- Sticky header background ---------- */
  function initSticky() {
    var hdr = document.querySelector('[data-header][data-sticky]');
    if (!hdr) return;
    var stuck = null;
    var onScroll = function () {
      var next = window.scrollY > 8;
      if (next !== stuck) { stuck = next; hdr.classList.toggle('is-stuck', next); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Auto-collapse: agar inline nav fit na ho -> hamburger ----------
     Lambe logo / bohot se menu items pe top nav centered logo pe overlap kar
     jaata tha. Yahan measure karke, jab nav logo se takraye, header ko
     'is-compact' de dete hain (nav hide, hamburger show). Har width + har
     content length pe khud adjust hota hai. */
  function initHeaderFit() {
    // hamari header dhoondo via apni nav (Dawn ke [data-header] se clash na ho)
    var nav = document.querySelector('.header__nav--desktop');
    if (!nav) return;
    var header = nav.closest('.header') || nav.closest('[data-header]');
    if (!header) return;
    var logo = header.querySelector('.header__logo');
    var actions = header.querySelector('.header__actions');
    if (!logo || !actions) return;

    var raf;
    function check() {
      // pehle compact hata kar natural layout measure karo
      header.classList.remove('is-compact');
      // ≤ breakpoint pe CSS media khud hamburger dikhata hai -> nav hidden -> skip
      if (getComputedStyle(nav).display === 'none') return;
      var n = nav.getBoundingClientRect();
      var l = logo.getBoundingClientRect();
      var a = actions.getBoundingClientRect();
      var overlaps = n.right > l.left - 8 || l.right > a.left - 8;
      if (overlaps) header.classList.add('is-compact');
    }
    function onResize() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(check);
    }
    window.addEventListener('resize', onResize, { passive: true });
    // fonts load hone ke baad width badalti hai -> dobara check
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    check();
  }

  /* ---------- Quick / predictive search ----------
     Jab search field me type karo to neeche live product suggestions
     (Shopify /search/suggest.json se). */
  function initPredictiveSearch() {
    var form = document.querySelector('.header__search');
    if (!form) return;
    var input = form.querySelector('input[type="search"], input[name="q"]');
    if (!input) return;
    input.setAttribute('autocomplete', 'off');

    var box = document.createElement('div');
    box.className = 'header__search-results';
    box.setAttribute('hidden', '');
    form.appendChild(box);

    var root = shopRoot();
    var timer;

    function priceOf(p) {
      var pr = p.price;
      if (pr === undefined || pr === null || pr === '') return '';
      if (typeof pr === 'number') return money(Number.isInteger(pr) ? pr : Math.round(pr * 100));
      if (/^\d+$/.test(pr)) return money(parseInt(pr, 10));                  // cents string "2499"
      if (/^\d+([.,]\d+)?$/.test(pr)) return money(Math.round(parseFloat(pr.replace(',', '.')) * 100)); // decimal "24.99" / "24,99"
      return pr;                                                             // already formatted "€ 24,99"
    }
    function imgOf(p) {
      if (p.image) return p.image;
      if (p.featured_image) return (typeof p.featured_image === 'string') ? p.featured_image : p.featured_image.url;
      return '';
    }
    function render(products, q) {
      if (!products.length) {
        box.innerHTML = '<div class="hsr__empty">Geen resultaten voor "' + esc(q) + '"</div>';
        box.removeAttribute('hidden'); return;
      }
      box.innerHTML = products.map(function (p) {
        var img = imgOf(p), price = priceOf(p);
        return '<a class="hsr__item" href="' + esc(p.url) + '">' +
          (img ? '<img class="hsr__img" src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="hsr__img"></span>') +
          '<span class="hsr__meta"><span class="hsr__title">' + esc(p.title) + '</span>' +
          (price ? '<span class="hsr__price">' + esc(price) + '</span>' : '') +
          '</span></a>';
      }).join('') +
      '<a class="hsr__all" href="' + esc(root + '/search?q=' + encodeURIComponent(q)) + '">Alle resultaten voor "' + esc(q) + '" →</a>';
      box.removeAttribute('hidden');
    }
    function doSearch(q) {
      var url = root + '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || input.value.trim() !== q) return;
          var products = (d.resources && d.resources.results && d.resources.results.products) || [];
          render(products, q);
        })
        .catch(function (err) { if (window.console) console.error('[SundayHome] search error:', err); });
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { box.setAttribute('hidden', ''); return; }
      timer = setTimeout(function () { doSearch(q); }, 220);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && box.innerHTML) box.removeAttribute('hidden');
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { box.setAttribute('hidden', ''); closeMobileSearch(); } });

    // Mobile: search-icon (button) full-width search bar toggle karta hai
    var header = form.closest('.header');
    var toggle = document.querySelector('[data-search-toggle]');
    function closeMobileSearch() { if (header) header.classList.remove('search-open'); }
    if (toggle && header) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = header.classList.toggle('search-open');
        if (open) { setTimeout(function () { input.focus(); }, 40); }
        else { box.setAttribute('hidden', ''); }
      });
    }
    document.addEventListener('click', function (e) {
      var inForm = form.contains(e.target);
      var inToggle = toggle && toggle.contains(e.target);
      if (!inForm) box.setAttribute('hidden', '');
      if (!inForm && !inToggle) closeMobileSearch();
    });
    if (window.console) console.log('[SundayHome] quick search ready');
  }

  document.addEventListener('DOMContentLoaded', function () {
    // har init alag try/catch me — ek fail ho to baaki (auto-collapse samet) chalte rahein
    [initDrawer, initCartDrawer, initWishlistButtons, renderWishlistPage, trackRecent, renderRecent,
     initSticky, initHeaderFit, initPredictiveSearch].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.error('[SundayHome] init error:', e); }
    });
  });
})();